import {api} from '../../lib/api'
import {get_message as $m} from '../../lib/messages'
import {notify, okcancel} from '../../lib/notifications'
import {error_handler, get_bugsnag} from '../../lib/util'
import {loading} from '../../lib/ui'

const process_cancel_donation = async (regular_donation) => {
  const bugsnag = get_bugsnag()
  const {customer_id, period, subscription_id: current_subscription_id, amount} = regular_donation

  loading('show', $m('CANCEL_DONATION_UPDATING'))

  try {
    const {status} = await api.delete(`/donations`, {
      current_subscription_id
    })

    if(status !== 200) {
      bugsnag.leaveBreadcrumb(`
        current_subscription_id = ${current_subscription_id}
        customer_id = ${customer_id}
        amount = ${amount}
        period = ${period}
      `)

      throw new Error(`status = ${status}, DELETE /members/donations`)
    }

    notify($m('CANCEL_DONATION_UPDATED'), 'success', () => {
      loading('show', $m('ACCOUNT_RELOADING'))
      setTimeout(() => window.location.reload(), 1000)

      return false
    })
  }
  catch(error) {
    error_handler(error)
  }
}

export const cancel_donation = async (email, regular_donation) => {
  const bugsnag = get_bugsnag()
  const {period, amount} = regular_donation

  bugsnag.leaveBreadcrumb(`cancel donation | ${email}`)

  const {first_name} = JSON.parse(sessionStorage.user)
  const question = $m('CANCEL_DONATION_CONFIRM', first_name, period, amount)
  okcancel(question, () => {
    process_cancel_donation(regular_donation)

    return false
  })
}
